import { useQuery } from "@tanstack/react-query";
import axiosInstance from "utils/axios";

export const getTenantSplashColors = async () => {
  return axiosInstance
    .get(`institute/getTenantSplashColors`)
    .then((response) => response.data?.data)
    .catch((error) => {
      return error.response.data;
    });
};

export const useTenantSplashColors = () => {
  return useQuery({
    queryKey: ["get-tenant-splash-colors"],
    queryFn: getTenantSplashColors,
    options: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: Infinity,
    },
  });
};
